import { api } from '../../../../app/baseQuery';
import { HTTPResponse } from '../../../../common/types/commonTypes';
import {
  ICreditLimitHistory,
  ICreditLimitList,
  IPostCreditLimit,
} from '../type/CreditLimit.interface';

export const creditLimitApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCreditLimit: build.query<HTTPResponse<ICreditLimitList[]>, void>({
      query: () => {
        return {
          url: `/client/all-secret-clients`,
          method: 'GET',
        };
      },
      providesTags: () => ['employee_target'],
    }),

    addCreditLimit: build.mutation<HTTPResponse<void>, IPostCreditLimit[]>({
      query: (body) => {
        return {
          url: `/client/bulk-update-credit-limit`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: () => ['employee_target'],
    }),
    creditLimitHistory: build.query<HTTPResponse<ICreditLimitHistory[]>, { id: number | string }>({
      query: ({ id }) => {
        return {
          url: `/client/bulk-update-credit-limit/${id}`,
          method: 'GET',
        };
      },
      providesTags: () => ['employee_target'],
    }),
  }),
});
export const { useGetCreditLimitQuery, useAddCreditLimitMutation, useCreditLimitHistoryQuery } =
  creditLimitApi;
